<template>
    <div class="quiz">
        <QuizProgress
            v-if="!is_finished"
            :quiz_state=this.getQuizState()
            :quiz_data=quiz_data
        />

        <Question
            v-if="!is_finished"
            :key="current_question"
            :quiz_data=quiz_data
            :question=quiz_data.questions[current_question]
            :is_final=is_final
            v-on:handle-step-submit="handleStepSubmit"
        ></Question>

        <Results
            v-if="is_finished"
            :quiz_data=quiz_data
            :quiz_state=this.getQuizState()
        ></Results>
    </div>
</template>

<script>
import Question from '@/components/Question';
import Results from '@/components/Results';
import QuizProgress from '@/components/QuizProgress';
import storage from 'local-storage-fallback';

export default {
    name: "Quiz",
    props: {
        quiz_data: Object //just pass in the whole quiz object
    },
    components: {
        Question,
        Results,
        QuizProgress
    },
    data() {
        return {
            total_questions: 0,
            current_question: 0,
            is_final: false,
            is_finished: false
        }
    },
    methods: {
        getQuizStateKey() {
            let prefix = process.env.VUE_APP_STORAGE_PREFIX;
            let quiz_id = this.quiz_data.quiz_id;
            return prefix + "_" + quiz_id + "_state";
        },
        getQuizState() {
            let state = JSON.parse(storage.getItem(this.getQuizStateKey()));

            if (state === null) {
                state = {
                    current_question: 0,
                    answers: []
                };
            }

            return state;
        },

        saveQuizState(state) {
            storage.setItem(this.getQuizStateKey(), JSON.stringify(state));
        },

        initQuiz() {
            let quiz_state = this.getQuizState();

            this.current_question = quiz_state.current_question;

            this.total_questions = this.quiz_data.questions.length;

            this.is_final = (this.current_question === this.total_questions - 1);

            this.is_finished = (this.current_question >= this.total_questions);
        },

        handleStepSubmit(action, step) {
            let state = this.getQuizState();

            document.querySelector("html, body").scrollTop = 0;

            if (step.$refs.email) {
                state.email = step.$refs.email.getValue();
            }

            if (step.$refs.country) {
                state.country = step.$refs.country.getValue();
            }

            if (step.$refs.region) {
                state.region = step.$refs.region.getValue();
            }

            if (step.$refs.source) {
                state.source = step.$refs.source.getValue();
            }

            if (step.$refs.answer) {
                let question_data = this.quiz_data.questions[this.current_question];

                state.answers.push({
                    question: this.current_question,
                    answer: step.$refs.answer.getValue()
                });

                if(question_data.hasOwnProperty('special_field')) {
                    state[question_data.special_field] = step.$refs.answer.getValue();
                }
            }

            if (action === "finishsubscribe") {
                state.subscribe = true;
            }

            this.current_question++;
            state.current_question = this.current_question;

            this.is_final = (this.current_question === this.total_questions - 1);
            this.is_finished = (this.current_question === this.total_questions);

            if(this.is_finished) {
                state = this.setWinner(state);

                if(!state.submitted) {
                    this.submitToServer(state);
                }
            }

            this.saveQuizState(state);
        },
        submitToServer(state) {
            fetch('/api/submissions/add', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(state)
            }).then(response => response.json())
                .then(() => {
                    state.submitted = true;
                    this.saveQuizState(state)
                });
        },
        setWinner(state) {
            let answers = state.answers;

            let outcomes = {};

            answers.forEach((answer) => {
                if (this.quiz_data.questions[answer.question].type !== "optionset") return;

                let answer_outcomes = this.quiz_data.questions[answer.question].options[answer.answer].outcome_values;

                answer_outcomes.forEach((letter) => {
                    if (outcomes[letter] != null) {
                        outcomes[letter]++;
                    } else {
                        outcomes[letter] = 1;
                    }
                });
            });

            state.outcome = Object.keys(outcomes).reduce((a, b) => outcomes[a] > outcomes[b] ? a : b);

            return state;
        }
    },
    created() {
        this.initQuiz();
    }
}
</script>

<style scoped lang="stylus">
.quiz {
    display: flex;
    flex: 1;
    position: relative;
    font-size: 1.2em;
    background: mix(brand-taupe, white, 10);

    @media (min-width: 700px) {
        font-size: 1.3em;
    }
}
</style>